module.exports = __webpack_public_path__ + "static/media/USDC-logo.387fd762.png";